import React from 'react'
import './FeedBack.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/free-solid-svg-icons'

function FeedBack({ name, work, src }) {
    return (
        <div className="feedBack">
            <div className="avatar">
                <img src={src} alt="client avatar" />
            </div>
            <div className="starts">
                <FontAwesomeIcon icon={faStar} />
                <FontAwesomeIcon icon={faStar} />
                <FontAwesomeIcon icon={faStar} />
                <FontAwesomeIcon icon={faStar} />
                <FontAwesomeIcon icon={faStar} />
            </div>
            <div className="feedBack__info">
                <div className="info__name">
                    <p className="name">{name}</p>
                    <span>{work}</span>
                </div>
                <p>Eu dolor excepteur pariatur exercitation et nostrud duis deserunt mollit magna nostrud id Lorem. Duis amet elit ipsum amet consequat dolore sint. Consequat qui velit nulla ea cupidatat incididunt et ea adipisicing.</p>
            </div>
        </div>
    )
}

export default FeedBack
